<template>
  <div>
    <div class="main-banner" id="home">
      <!--/banner-->
      <div class="banner-info">
        <div class="w3pvt-logo text-center">
          <h1>
            <a href="https://404.life/">404网页模板</a>
          </h1>
        </div>
        <div class="middile-inner-con">
          <section class="inner-w3layouts-wrap">
            <h4>
              抱歉，当你看到这个页面的时候，表示你要找的网页已经丢失了。
              <br />
              <br />别担心，你可以返回首页继续你的网站之旅！
            </h4>
          </section>
          <div class="tab-main mx-auto">
            <label>
              <span class="fa fa-home" aria-hidden="true"></span>
              <!-- <a target="_blank" href="https://404.life/">首页</a> -->
              <router-link :to="{path: '/'}">首页</router-link>
            </label>
          </div>
          <!--// banner-inner -->
        </div>
      </div>
      <div class="copy-w3layouts-right text-center pb-3">
        <p>
          Copyright &copy; 2019
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
<style scoped>
@import './css/bootstrap.css';
@import './css/font-awesome.css';
@import './css/style.css';
</style>